module.exports = __webpack_public_path__ + "img/ideal.77ef8924.png";